<template>
    <b-button
        @click="show()"
        size="sm"
        :disabled="disabled"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
        block
    ><!-- button --> 
        <span v-if="httpRequestInProgress">
            <b-spinner
                type="grow"
                label="Loading..."
                small
            />
        </span>
        <span v-else>Neu bestellen</span>
        <b-modal
            v-model="modalState"
            id="modal-unfreeze-order"
            title="Neu bestellen"
            size="md"
            cancel-disabled
            centered
        ><!-- modal -->

            <span>Diese Bestellung wirklich erneut bestellen?</span>
            <div v-if="customerOrder.customerorderitems[0].quantity > 1" class="d-flex flex-wrap">
                <div class="pt-1 pr-1"><span>Anzahl: </span></div>
               <div><b-input v-model="newQuantity" size="sm" block /></div>
            </div>

            <div slot="modal-footer" class="w-100">
              <b-button
                  centered
                  size="md"
                  class="float-right mx-1"
                  variant="secondary"
                  @click="close()"
               >abbrechen</b-button>
               <b-button
                  centered
                  size="md"
                  class="float-right mx-1"
                  variant="danger"
                  @click="submit()"
               >neu bestellen</b-button>

               <!--b-btn size="md" class="float-right" variant="secondary" @click="close()">
                    abbrechen
               </b-btn -->
            </div>
        </b-modal>

        <b-modal
            v-model="modalSuccessState"
            id="modal-success-dialog"
            title="Umbestellen"
            size="sm"
            centered
            @hidden="() => { this.modalState = false; this.userConsent = false }"
        ><!-- modal -->
            Erfolgreich neubestellt.
            <div slot="modal-footer" class="w-100">
               <b-button
                  centered
                  size="md"
                  class="float-right mx-1"
                  variant="success"
                  @click="() => {this.modalState = false; this.modalSuccessState = false }"
               >schliessen</b-button>
            </div>
        </b-modal>
    </b-button>
</template>
<script>
    export default {
        props: ['customerOrder', 'orderStates', 'authorization']
        ,data() {
            return {
                modalState: false
              , modalSuccessState: false
              , httpRequestInProgress: false
              , userConsent: false
              , newQuantity: null
            }
        },
        computed: {
           disabled: function() {
               // if in state "Erstattung ausstehend" (aka REFUND), disable the button.
               if(this.customerOrder.orderState == this.orderStates.codes.REFUND) return true;

                // disallow action if we arent in state New or if we have the article in Lager.
                  return (this.customerOrder.orderState != this.orderStates.codes.NEW)
                  || this.customerOrder.customerorderitems[0].stock.vendorName.includes('Lager');
                // return false;
            }
        },
        methods: 
        {
            show() {
                this.newQuantity =this.customerOrder.customerorderitems[0].quantity;
                //console.log("newQuantity", this.newQuantity);
                this.modalState = true;
            },
            close() {
                this.modalState = false;
            },
            submit() {
              const payload = {
                    customerOrderId: this.customerOrder.id
                  , stockId:  this.customerOrder.customerorderitems[0].stockId
                  , quantity: this.newQuantity
                };
                //console.log("payload:", payload);
                this.httpRequestInProgress = true;
                Promise.all([
                    axios.post('/customerorder/action/reorder', payload),
                    new Promise(r => setTimeout(r, 750))
                ]).then( () => {
                    this.httpRequestInProgress = false;
                    this.modalSuccessState = true;
                }).catch( error => {
                    alert("Konnte Bestellung nicht neu bestellen.");
                    console.error(error);
                });
            }
        }
    }
</script>
